var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',[_c('v-col',[_c('SendMessageForm',{attrs:{"mode":"about"},on:{"onSubmit":_vm.sendMsg}}),_c('AlertModal',{attrs:{"show":_vm.modal,"message":_vm.modalMsg},on:{"onConfirm":function($event){_vm.modal = false}}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }